import { createI18n } from "vue-i18n";
import messages from "@intlify/unplugin-vue-i18n/messages";

function loadLocaleFromBrowser() {
  const localStorageLanguage = window.localStorage?.getItem("language");
  if (
    localStorageLanguage &&
    ["de", "fr", "it"].includes(localStorageLanguage)
  ) {
    return localStorageLanguage;
  }

  return (
    "languages" in navigator &&
    navigator.languages
      .map((lang) => {
        return lang.split("-")[0]; // 'de-CH' -> 'de'
      })
      .find((lang) => ["de", "fr", "it"].includes(lang))
  );
}

export default createI18n({
  legacy: false,
  locale:
    localStorage.getItem("currentLocale") ||
    loadLocaleFromBrowser() ||
    import.meta.env.VITE_I18N_LOCALE ||
    "de",
  fallbackLocale: import.meta.env.VITE_I18N_FALLBACK_LOCALE || "de",
  globalInjection: true,
  messages,
});
